import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { pathgen } from 'object-path-generator';
import { useResponsive } from '~/client-flow/contexts';
import { CreateAVendorAccount } from '~/components/NavigationAndStructure/TopBar/CreateAVendorAccount';
import { useStoreActions } from '~/contexts';
import styles from './TryAnchorBanner.module.scss';
export const TryAnchorBannerDataTestIds = pathgen('TryAnchorBannerDataTestIds');
const TryAnchorBanner = (param)=>{
    let { showBanner, contentShift } = param;
    const { isDesktop } = useResponsive();
    const { logBI } = useStoreActions();
    const banner = /*#__PURE__*/ _jsx(AnimatePresence, {
        children: showBanner && /*#__PURE__*/ _jsx(motion.div, {
            className: cn(styles.bannerWrapper, {
                [styles.desktop]: isDesktop,
                [styles.mobile]: !isDesktop,
                [styles.notFixed]: true
            }),
            initial: {
                opacity: 0
            },
            animate: {
                opacity: 1
            },
            exit: {
                opacity: 0
            },
            transition: {
                duration: 0.3,
                ease: 'easeOut'
            },
            children: /*#__PURE__*/ _jsx(CreateAVendorAccount, {
                variant: "banner",
                onClick: ()=>logBI(18105),
                testId: TryAnchorBannerDataTestIds.CreateVendorAccountBtn()
            })
        })
    });
    return /*#__PURE__*/ _jsx("div", {
        className: styles.bannerSlot,
        style: {
            minHeight: contentShift ? 140 : 0
        },
        "aria-hidden": !showBanner,
        "data-testid": TryAnchorBannerDataTestIds.BannerSlot(),
        children: banner
    });
};
export default TryAnchorBanner;
